import React from 'react';

/**
 * Confirmation dialog for the destructive bulk delete. Restates the exact count
 * and the irreversible nature before anything happens; cancellable.
 *
 * Props: { count, busy, onConfirm, onCancel }
 */
const DeleteConfirm = ({ count = 0, busy = false, onConfirm, onCancel }) => (
  <div className="uv-modal-backdrop" data-testid="delete-confirm" role="dialog" aria-modal="true" aria-label="Confirm delete user data">
    <div className="uv-modal">
      <h3 className="uv-modal__title">Delete data for {count} {count === 1 ? 'user' : 'users'}?</h3>
      <p className="uv-modal__body">
        This permanently deletes all stored data for the selected {count === 1 ? 'user' : 'users'} across every table.
        <b> This cannot be undone.</b>
      </p>
      <div className="uv-modal__actions">
        <button type="button" className="uv-state__btn" data-testid="delete-cancel" onClick={onCancel} disabled={busy}>Cancel</button>
        <button type="button" className="uv-modal__danger" data-testid="delete-confirm-btn" onClick={onConfirm} disabled={busy}>
          {busy ? 'Deleting…' : `Delete ${count} ${count === 1 ? 'user' : 'users'}`}
        </button>
      </div>
    </div>
  </div>
);

export default DeleteConfirm;
